import type { FC } from "react";
import React from "react";

import {
  GRID_COLUMNS,
  GRID_LINE_WIDTH,
  GRID_PAST_DAYS,
  GRID_ROWS,
} from "../../../bootstrap/grid.ts";

// oxlint-disable-next-line no-warning-comments
// TODO(APT-252): move these colors into the Tailwind theme.
const EMPTY_FUTURE = "hsl(225deg 18% 91%)";

const EMPTY_PAST = "hsl(225deg 15% 94%)";

const CELL_RADIUS = 0.13;

const NOTCH_WIDTH = 0.56;

const NOTCH_HEIGHT = 0.12;

const NOTCH_RADIUS = 0.06;

const TODAY_ROW = GRID_ROWS - 1 - GRID_PAST_DAYS;

const COLS = Array.from({ length: GRID_COLUMNS }, (_value, index) => index);

const ROWS = Array.from({ length: GRID_ROWS }, (_value, index) => index);

export const GridCells: FC = () => (
  <>
    {ROWS.map(row =>
      COLS.map(col => (
        <rect
          fill={row > TODAY_ROW ? EMPTY_PAST : EMPTY_FUTURE}
          height={1}
          key={`${row}-${col}`}
          rx={CELL_RADIUS}
          stroke="var(--background)"
          strokeWidth={GRID_LINE_WIDTH}
          width={1}
          x={col}
          y={row}
        />
      )),
    )}
    <rect
      fill="var(--primary)"
      height={NOTCH_HEIGHT}
      rx={NOTCH_RADIUS}
      width={NOTCH_WIDTH}
      x={-NOTCH_WIDTH / 2}
      y={TODAY_ROW - NOTCH_HEIGHT / 2}
    />
    <rect
      fill="var(--primary)"
      height={NOTCH_HEIGHT}
      rx={NOTCH_RADIUS}
      width={NOTCH_WIDTH}
      x={GRID_COLUMNS - NOTCH_WIDTH / 2}
      y={TODAY_ROW - NOTCH_HEIGHT / 2}
    />
  </>
);
